<generic-modal class="add-photos-modal" #addPhotosModal [hideOnBackdropClick]="false">
	<ng-template #modalHeading>
		<div class="header-container">
			<div class="close-action">
				<button mat-button (click)="onClose()">
					<mat-icon>close</mat-icon>
				</button>
			</div>
			<div class="name-container">
				<span>Site Note Photos</span>
			</div>
		</div>
	</ng-template>
	<ng-template #modalBody>
		<div>
			<div *ngIf="files.length === 0">
				No photo selected
			</div>
			<div class="photos-wrapper">
				<div class="photo" *ngFor="let file of files">
					<div class="thumbnail">
						<img [src]="file.thumbnail" alt="img">
					</div>
					<div class="details">
						<span class="photo-name">{{file.name}}</span>
					</div>
					<div class="delete-action">
						<button mat-icon-button title="Delete" (click)="onDeletePhoto(file)">
							<mat-icon>delete</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
	</ng-template>
	<ng-template #modalActions>
		<action-button class="add-photos-action" [icon]="ButtonIcons.AddPhoto" [name]="'Add Photos'"
			(click)="onClickAddPhoto(fileInput)"></action-button>
	</ng-template>
</generic-modal>
<input type="file" name="photos-input" hidden #fileInput (change)="onChangePhotos($event.target.files, fileInput)"
	multiple="multiple" accept=".jpg, .jpeg, .png" />